// extracted by mini-css-extract-plugin
export default {"root":"Backdrop_root__Jg3J7","dark":"Backdrop_dark__5UDFm","blur":"Backdrop_blur__Yonzk"};